<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="less">
@import '../src/common/reset.css';
@import '../src/common/index.less';
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0 auto;
  // max-width: 480px;
  > div {
    width: 100% !important;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue